import timeline from "../assets/pictures/sandra-fotel.webp"
import timeline2 from "../assets/pictures/Wiz9.webp"
import timeline3 from "../assets/pictures/sandra-ksiazka.webp"
import timeline4 from "../assets/pictures/Wiz8.webp"
import timeline5 from "../assets/pictures/1000038629.webp"
import obraz from "../assets/pictures/115.jpg"
import obraz2 from "../assets/pictures/7.webp"

export const navLinks = [
  { name: "STRONA GŁÓWNA", path: "/" },
  { name: "O MNIE", path: "/about" },
  { name: "PORTFOLIO", path: "/realizacje" },
  { name: "CENNIK", path: "/oferta" },
  { name: "KONTAKT", path: "/kontakt" },
];

export const timelineData = [
 {
    id: "01",
    title: "KONSULTACJE PROJEKTOWE",
    description: [
      "Indywidualne konsultacje, podczas których omawiamy potrzeby i oczekiwania klienta.",
      "Analiza przestrzeni i doradztwo w zakresie rozwiązań projektowych.",
      "Propozycje stylów, kolorystyki oraz materiałów.",
    ],
    image: timeline,
  },
  {
    id: "02",
    title: "PROJEKT KONCEPCYJNY",
    description: [
      "Opracowanie wstępnych koncepcji projektowych.",
      "Wizualizacje 3D, ukazujące różne możliwości aranżacji wnętrza.",
      "Prezentacja moodboardów z inspiracjami i propozycjami wykończeń.",
    ],
    image: timeline5,
  },
  {
    id: "03",
    title: "PROJEKT WYKONAWCZY",
    description: [
      "Szczegółowe rysunki techniczne, obejmujące układ pomieszczeń, elektrykę, hydraulikę i oświetlenie.",
      "Dobór materiałów, mebli i dekoracji. ",
      "Kosztorys projektu.",
    ],
    image: timeline3,
  },
  {
    id: "04",
    title: "NADZÓR AUTORSKI",
    description: [
      "Kontrola realizacji projektu zgodnie z założeniami. ",
      " Regularne wizyty na budowie i współpraca z wykonawcami.",
      " Konsultacje w trakcie realizacji projektu i rozwiązywanie ewentualnych problemów.",
    ],
    image: timeline4,
  },
];

 export const squares = [
    { name: "REALIZACJE", path: "/realizacje", img: obraz },
    { name: "OFERTA", path: "/oferta", img: timeline2 },
    { name: "KONTAKT", path: "/kontakt", img: obraz2  },
  ];